if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        const shopifyPaymentBtn = document.querySelector('.shopify-payment-button__button--unbranded');
        if (shopifyPaymentBtn) {
          shopifyPaymentBtn.addEventListener('click', function (e) {
            const btnBuyItNow = document.querySelector('shop-pay-wallet-button');
            btnBuyItNow?.handleClick(e);
          });
        }
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.initSizeTranslation();
        this.addPreProcessCallback(this.initSizeTranslationCallback.bind(this));
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        this.initProductImageZoomLightBox();
        this.saveRecentlyViewedProduct();
      }

      initProductImageZoomLightBox() {
        const gallerySelector = '.product__media-list.contains-media.grid.grid--peek, .swiper-wrapper.contains-media';
        const childrenSelector = '.product-thumbnail-desktop a.zoom-light-box.image, .product-thumbnail-mobile a.zoom-light-box.image, a.zoom-light-box.image';

        const options = {
          gallery: gallerySelector,
          children: childrenSelector,
          mouseMovePan: true,
          initialZoomLevel: 3,
          secondaryZoomLevel: 'fit',
          maxZoomLevel: 4,
          wheelToZoom: true,
          pswpModule: PhotoSwipe,
        };
        const lightbox = new PhotoSwipeLightbox(options);
        const thumbImages = this.querySelectorAll(
          '.product__media-list.contains-media .product-thumbnail-mobile img[class*="image-magnify"], ' +
          '.swiper-wrapper.contains-media .product-thumbnail-mobile img[class*="image-magnify"]'
        );

        lightbox.on('uiRegister', function () {
          lightbox.pswp.ui.registerElement({
            name: 'bulletsIndicator',
            className: 'pswp__bullets-indicator',
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
              const bullets = [];
              let prevIndex = -1;

              for (const value of thumbImages) {
                value.classList.add('rimage__image');
                const galleryViewerThumb = document.createElement('a');
                galleryViewerThumb.classList.add('gallery-viewer-thumb');

                galleryViewerThumb.innerHTML =
                  `<div class="rimage-outer-wrapper">
                        <div class="rimage-wrapper">` +
                  value.outerHTML +
                  ` </div>
                      </div>`;
                el.append(galleryViewerThumb);
              }

              const imageList = el.querySelectorAll('img[class*="image-magnify"]');
              for (var i = 0; i < pswp.getNumItems(); i++) {
                const image = imageList[i];
                if (image) {
                  image.addEventListener('click', (e) => {
                    e.preventDefault();
                    pswp.goTo(bullets.indexOf(e.target));
                  });
                  bullets.push(image);
                }
              }

              pswp.on('change', (a) => {
                if (prevIndex >= 0) {
                  bullets[prevIndex].classList.remove('svifaded');
                }
                bullets[pswp.currIndex].classList.add('svifaded');
                prevIndex = pswp.currIndex;
              });
            },
          });
        });

        lightbox.init();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initSizeTranslationCallback(html) {
        const sizeTranslation = html.querySelector('button-group.size-translation');
        if (!sizeTranslation) return;
        const buttons = sizeTranslation.querySelectorAll('button');
        buttons.forEach((button, index) => {
          if (index === this.sizeSelectedIndex) {
            button.classList.add('selected');
          } else {
            button.classList.remove('selected');
          }
        });
        const attributeContainer = sizeTranslation.parentElement;
        const attribute = this.sizeSelectedAttribute || 'value';
        const labels = attributeContainer.querySelectorAll('label');
        labels.forEach((label) => {
          const input = attributeContainer.querySelector(`input[id="${label.getAttribute('for')}"]`);
          if (input) {
            const swatch = label.querySelector('.swatch');
            const value = input.getAttribute(attribute) || input.getAttribute('data-' + attribute);
            if (!value) return;
            if (swatch) {
              label.title = value;
            } else {
              label.innerText = value;
            }
          }
        });
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      initSizeTranslation() {
        const sizeTranslation = this.querySelector('button-group.size-translation');
        if (!sizeTranslation) return;
        if (this.sizeSelectedIndex) {
          sizeTranslation.select(this.sizeSelectedIndex);
        }
        const attributeContainer = sizeTranslation.parentElement;
        const valueAttribute = sizeTranslation.dataset.valueAttribute;
        const checkedInput = attributeContainer.querySelector('input:checked');
        const translationValue =
          checkedInput.getAttribute(valueAttribute) || checkedInput.getAttribute('data-' + valueAttribute);
        if (checkedInput && translationValue) {
          const sizeTranslationInput = this.querySelector(`input[name="${sizeTranslation.dataset.cartProperty}"]`);
          if (sizeTranslationInput) {
            sizeTranslationInput.value = translationValue;
          }
        }
        sizeTranslation.addEventListener('amb-button-group:changed', (props) => {
          const selected = props.detail.selected;
          const attribute = selected.dataset.option;
          const attributeContainer = props.target.parentElement;
          const labels = attributeContainer.querySelectorAll('label');
          labels.forEach((label) => {
            const input = attributeContainer.querySelector(`input[id="${label.getAttribute('for')}"]`);
            if (input) {
              const swatch = label.querySelector('.swatch');
              const value = input.getAttribute(attribute) || input.getAttribute('data-' + attribute);
              if (!value) return;
              if (swatch) {
                label.title = value;
              } else {
                label.innerText = value;
              }
            }
          });
          this.sizeSelectedIndex = props.detail.selectedIndex;
          this.sizeSelectedAttribute = attribute;
        });
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;

        const promotion = {
          promotionCallout: target.dataset.promotionCallout,
          promotionColor: target.dataset.promotionColor,
        };

        const specifications = {
          weight: target.dataset.specificationsWeight,
          unit_weight: target.dataset.specificationsUnitWeight,
          label_weight: target.dataset.specificationsLabelWeight,
          diameter: target.dataset.specificationsDiameter,
          label_diameter: target.dataset.specificationsLabelDiameter,
          unit_length_and_diameter: target.dataset.specificationsUnitLengthAndDiameter,
          length: target.dataset.specificationsLength,
          label_length: target.dataset.specificationsLabelLength,
        };

        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl.replace(/\?.*$/, '');
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl, promotion, specifications),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        url = new URL(window.shopUrl + url);

        if (!shouldFetchFullPage) {
          url.searchParams.set('section_id', this.sectionId);
        }

        if (!url.searchParams.has('variant') && optionValues.length) {
          url.searchParams.set('option_values', optionValues.join(','));
        }

        return `${url.pathname}${url.search}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
          this.initSizeTranslation();
        }
      }

      handleUpdateProductInfo(productUrl, promotion, specifications) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          let updateVariant = false;

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            const inputPills = this.querySelectorAll('.product-form__input--pill:not(.color--pill)');
            for (let i = 0; i < inputPills.length; i++) {
              const checkedInput = inputPills[i].querySelector('input[checked]:not(.disabled)');

              if (!checkedInput) {
                const defaultCheckedInputId = inputPills[i].querySelector('input:not(.disabled)')?.id;

                if (defaultCheckedInputId) {
                  const labelElement = inputPills[i].querySelector('label[for="' + defaultCheckedInputId + '"]');
                  if (labelElement) {
                    labelElement.click();
                    this.productForm?.toggleSubmitButton(false);
                    updateVariant = true;
                  } else {
                    console.warn(`Label for input ID "${defaultCheckedInputId}" not found.`);
                  }
                } else {
                  const fallbackLabel = inputPills[i].querySelector('label');
                  if (fallbackLabel) {
                    fallbackLabel.click();
                  } else {
                    console.warn('No label found to click as a fallback.');
                  }
                }
              } else {
                this.setUnavailable();
                return;
              }
            }
          }

          this.updateSpecifications(specifications);

          this.updateMedia(html, variant?.featured_media?.id);

          this.updateDeliveryOptions(html);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('size-hint');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          if (!updateVariant) {
            this.productForm?.toggleSubmitButton(
              html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
              window.variantStrings.unavailable
            );

            const floatingAddButton = document.querySelector('button[name="floating-add"]');
            const isSoldOut =
              html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true;

            if (floatingAddButton) {
              if (isSoldOut) {
                floatingAddButton.classList.add('disabled');
                floatingAddButton.setAttribute('disabled', 'disabled');
                floatingAddButton.textContent = window.variantStrings.unavailable;
              } else {
                floatingAddButton.classList.remove('disabled');
                floatingAddButton.removeAttribute('disabled');
                floatingAddButton.textContent = window.variantStrings.addToCart;
              }
            }
          }
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        url = new URL(`${window.shopUrl}${url}`);

        if (variantId) {
          url.searchParams.set('variant', variantId);
        }

        this.querySelector('share-button')?.updateUrl(url.toString());

        if (this.dataset.updateUrl !== 'false') {
          window.history.replaceState({}, '', `${url.pathname}${url.search}`);
        }
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      /**
       * @param {HTMLElement} html
       * @param {string} [variantFeaturedMediaId]
       */
      updateMedia(html, variantFeaturedMediaId) {
        const selectors = ['ul[id^="Slider-Gallery"]', 'ul[id^="Slider-Thumbnails"]'];
        let shouldUpdate = undefined;
        let mediaCount = 0;

        for (const selector of selectors) {
          const mediaSource = this.querySelector(selector);
          const mediaDestination = html.querySelector(selector);

          if (mediaSource && mediaDestination) {
            if (shouldUpdate === undefined) {
              const sourceIds = Array.from(mediaSource.querySelectorAll('li[data-media-id]')).map(
                (item) => item.dataset.mediaId
              );
              const destinationIds = Array.from(mediaDestination.querySelectorAll('li[data-media-id]')).map(
                (item) => item.dataset.mediaId
              );

              shouldUpdate = sourceIds.join('|') !== destinationIds.join('|');
              mediaCount = destinationIds.length;
            }

            if (shouldUpdate) {
              mediaSource.innerHTML = mediaDestination.innerHTML;

              if (this.hasAttribute('data-zoom-on-hover')) {
                enableZoomOnHover(2);
              }

              if (mediaSource.classList.contains('thumbnail-list')) {
                mediaSource.classList.toggle('hidden', mediaCount <= 1);
              }
            }
          }
        }

        // set featured media as active in the media gallery
        if (variantFeaturedMediaId && shouldUpdate) {
          this.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );
        }

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);

        if (modalContent && newModalContent) {
          modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      updateSpecifications(specifications) {
        const weightHtml = this.querySelector('.amb-specifications .weight');
        const diameterHtml = this.querySelector('.amb-specifications .diameter');
        const lengthHtml = this.querySelector('.amb-specifications .length');

        if (specifications.weight && weightHtml) {
          weightHtml.innerHTML = `<span>${specifications.label_weight}</span>${specifications.weight}${specifications.unit_weight}`;
        } else if (weightHtml) {
          weightHtml.innerHTML = '';
        }

        if (specifications.diameter && diameterHtml) {
          diameterHtml.innerHTML = `<span>${specifications.label_diameter}</span>${specifications.diameter}${specifications.unit_length_and_diameter}`;
        } else if (diameterHtml) {
          diameterHtml.innerHTML = '';
        }

        if (specifications.length && lengthHtml) {
          lengthHtml.innerHTML = `<span>${specifications.label_length}</span>${specifications.length}${specifications.unit_length_and_diameter}`;
        } else if (lengthHtml) {
          lengthHtml.innerHTML = '';
        }
      }

      /**
       * @param {HTMLElement} html
       */
      updateDeliveryOptions(html) {
        this.querySelectorAll('.accordion-delivery-option > details').forEach((deliveryOptions) => {
          const shippingOptions = deliveryOptions.querySelector('shipping-options');

          if (shippingOptions) {
            const newDataScript = html.querySelector(
              `#${deliveryOptions.id} shipping-options script[name="data"][type="application/json"]`
            );

            try {
              shippingOptions.setData(JSON.parse(newDataScript.textContent));
            } catch (error) {
              console.error('ShippingOptions: Failed to parse data script JSON.', error);
            }
          }
        });
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      saveRecentlyViewedProduct() {
        const productIdInfo = document.querySelector('[data-product-id]');
        if (!productIdInfo) return;

        const key = 'theme:recently-viewed-products';
        const productId = productIdInfo.dataset.productId;

        let viewed = JSON.parse(localStorage.getItem(key) || '[]');
        viewed = viewed.filter(id => id !== productId);
        viewed.unshift(productId);
        localStorage.setItem(key, JSON.stringify(viewed.slice(0, 20)));
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
